/*!
 * Application Insights JavaScript SDK - Channel, 2.5.10
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */
import '@microsoft/applicationinsights-shims';
export { Sender } from "./Sender";
//# sourceMappingURL=applicationinsights-channel-js.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@microsoft/applicationinsights-channel-js/dist-esm/applicationinsights-channel-js.js
// module id = 307
// module chunks = 0